

stateDefinitions = ($stateProvider, TagUrl) ->
    'ngInject'

    $stateProvider.state 'reports.amc.grantReport',
        url: '/grant-report'
        templateUrl: 'reports/amc/grantReport'
        abstract: true

    $stateProvider.state 'reports.amc.grantReport.index',
        url: ''
        templateUrl: 'reports/amc/grantReportIndex'
        resolve: grantReports: resolveGrantReportIndex
        controllerAs: 'ctrl'
        controller: (@grantReports) ->

            @completePercent = (year) ->
                percent = if year.slots == 0 then 0 \
                    else year.complete / year.slots
                return Math.floor(percent * 100)

            return

    tagUrl = new TagUrl().addTagTypes(['program', 'location'])

    $stateProvider.state 'reports.amc.grantReport.view',
        url: tagUrl.buildUrl('/{year:int}?{page:int}{sort}{direction}')
        params: tagUrl.params
        data: tagUrl: tagUrl
        abstract: true
        reloadOnSearch: false
        templateUrl: 'reports/amc/grantReportView'
        resolve:
            config: resolveGrantReportConfig
        controllerAs: 'ctrl'
        controller: GrantReportViewController

    # $stateProvider.state 'reports.amc.grantReport.view.slots',
    #     reloadOnSearch: false
    #     url: ''
    #     resolve: report: resolveReport('slots')
    #     templateUrl: 'reports/amc/grantReportSlots'
    #     controller: ReportController
    #     controllerAs: 'ctrl'

    # $stateProvider.state 'reports.amc.grantReport.view.outcomes',
    #     reloadOnSearch: false
    #     url: '/outcomes'
    #     resolve: report: resolveReport('outcomes')
    #     templateUrl: 'reports/amc/grantReportOutcomes'
    #     controller: ReportController
    #     controllerAs: 'ctrl'

    sectionTemplates =
        slots: 'grantReportSlots'
        outcomes: 'grantReportOutcomes'
        info: 'grantReportInfo'

    $stateProvider.state 'reports.amc.grantReport.view.section',
        reloadOnSearch: false
        url: '/{section}'
        templateUrl: ($stateParams) ->
            name = sectionTemplates[$stateParams.section] or 'grantReportSection'
            return "reports/amc/#{name}"
        resolve:
            config: resoveSectionConfig
            report: resolveReport
        controller: ReportController
        controllerAs: 'ctrl'



### @ngInject ###
resolveGrantReportIndex = ($http, ApiUrl) ->
    url = ApiUrl('reports', 'amc', 'grant_report')
    return $http.get(url).then (response) -> response.data.items


### @ngInject ###
resolveGrantReportConfig = ($http, $stateParams, ApiUrl) ->
    url = ApiUrl('amc_grant_report', 'config', $stateParams.year)
    return $http.get(url).then (response) -> response.data.item


### @ngInject ###
resoveSectionConfig = ($stateParams, config) ->
    for section in config.sections.sections
        if section.name == $stateParams.section then return section
    return

### @ngInject ###
resolveReport =($stateParams, GrantReportReport, config) ->
    return new GrantReportReport($stateParams.year,
                                 $stateParams.section,
                                 config)


class GrantReportViewController

    ### @ngInject ###
    constructor: ($scope, $timeout, $stateParams, config) ->
        @scope = $scope
        @timeout = $timeout
        @config = config
        @grantYear = $stateParams.year

        @scope.triggerRefresh = @triggerRefresh

    refreshTags: (params) ->
        @timeout =>
            @lastParams = params
            @downloadUrl = @buildDownloadURL()
            @scope.$broadcast('tagRefresh', params)

    triggerRefresh: =>
        if @lastParams? then @refreshTags(@lastParams)

    buildDownloadURL: ->
        url = "/api/reports/amc/grant_report/#{@grantYear}.xlsx"
        parts = []
        for name, items of @lastParams
            for value in items
                parts.push "#{name}=#{encodeURIComponent(value)}"
        return  "#{url}?#{parts.join("&")}"


class ReportController

    ### @ngInject ###

    constructor: ($scope, @report) ->
        @scope = $scope

        @scope.triggerRefresh()
        @scope.$on 'tagRefresh', @refresh

        makeMetric = (label, col, percent=true) ->
            label: label
            act_col: col
            obj_col: col + '_objective'
            unit: if percent then '%' else ''
            mult: if percent then 100 else 1

        @outcomeMetrics = [
            makeMetric('Ed Award Rate', 'ed_award_rate')
        ]

        if @report.grant_year <= 2015
            @outcomeMetrics = @outcomeMetrics.concat([
                makeMetric('Full Ed Award', 'full_ed_award', false)
                makeMetric('Credential Rate', 'credential_rate')
                makeMetric('Job Placement', 'job_placement_rate')
            ])
        else
            @outcomeMetrics = @outcomeMetrics.concat([
                makeMetric('No Credential', 'no_credential', false)
                makeMetric('30 Day Credential Rate', 'credential_30d')
                makeMetric('1 Year Credential Rate', 'credential_1y')
                makeMetric('30 Day Job Placement', 'job_placement_30d')
                makeMetric('1 Year Job Placement', 'job_placement_1y')
            ])

    refresh: (event, params) =>
        @report.update(params)

    slotClasses: (item) ->
        num = item.members
        denom = item.slots

        green: num == denom
        red: num > denom
        blue: num == 0

    showDetails: (data, item) ->
        if @isShown(data, item) then @hideDetails()
        else
            @detailsData = data
            @detailsItem = item
        return

    hideDetails: () ->
        @detailsData = null
        @detailsItem = null
        return

    isShown: (data, item) ->
        return @detailsData? and \
            data.id == @detailsData.id and  \
            (not item? or item.name == @detailsItem.name)



class SectionController

    ### @ngInject ###
    constructor: (config) ->
        @config = config


### @ngInject ###
GrantReportReport = (Report) ->

    sortColumns =
        slots: ['name', 'completion', 'enrollment', 'total_slots',
                'members', 'planned']
        outcomes: ['name', "credential_rate_objective", "credential_rate",
                   "ed_award_rate_objective", "ed_award_rate",
                   "full_ed_award_objective", "full_ed_award",
                   "job_placement_objective", "job_placement",
                   "no_credential", "credential_1y", "credential_30d",
                   "job_placement_1y", "job_placement_30d"]
        info: ['name', 'members', 'applicants', 'confirm_80_20',
               'last_enrollment']

    class GrantReportReport extends Report
        @::$isList = true

        constructor: (@grant_year, @section, @config) ->
            @sortColumns = sortColumns[@section] or []

            if @config?
                @sortColumns = buildSortColumns(@config)
                @metrics = getConfigItems(@config, 'metric')
                @events = getConfigItems(@config, 'service_event')
                @narratives = getConfigItems(@config, 'narrative')

            super(['reports/amc/grant_report', @grant_year, @section])

        Object.defineProperties @prototype,
            $sorterConfig: get: ->
                default: 'name'
                columns: @sortColumns

        getConfigItems = (config, type) ->
            i for i in config.items when i.type == type

        buildSortColumns = (config) ->
            columns = []
            for item in config.items
                if item.type == 'metric'
                    columns.push item.name + '_actual'
                    if item.has_objective
                        columns.push item.name + "_objective"
                if item.type == 'service_event'
                    columns.push item.name + '_participated'
                if item.type == 'narrative'
                    columns.push item.name + '_word_count'

            return columns

    Report.addExtraParameter GrantReportReport, 'hide_disabled'

    return GrantReportReport


nameCellDirective = ->
    restrict: 'E'
    templateUrl: 'reports/amc/amcGrantReportNameCell'
    scope: data: '='
    link: (scope) ->
        scope.params = ->
            slug: scope.data?.slug
            grant_year: scope.data?.grant_year


detailsDirective = ->
    restrict: 'E'
    templateUrl: 'reports/amc/amcGrantReportDetails'
    scope:
        data: '='
        item: '='
        close: '&'
    link: (scope) ->
        scope.getData = (name) ->
            if name? then scope.data["#{scope.item.name}_#{name}"]
            else scope.data[scope.item.name]
        scope.click = ->
            scope.close
                item: scope.item
                data: scope.data


module.config stateDefinitions
module.directive('amcGrantReportDetails', detailsDirective)
module.directive('amcGrantReportNameCell', nameCellDirective)
module.service 'GrantReportReport', GrantReportReport
